import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeProfile,
  postJwtProfile,
} from "../../../helpers/fakebackend_helper"
import axiosApi from "helpers/api_helper"


export const getProfile = createAsyncThunk('profile/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/profile', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const updateProfile = createAsyncThunk('profile/update', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosApi.put('player/updateProfile', data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const getPerformance = createAsyncThunk('performance/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/performance', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const addPerformance = createAsyncThunk('performance/post', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosApi.post('player/performance', data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const ChangePerformance = createAsyncThunk('performance/put', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosApi.put('player/performance', data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const addhistory = createAsyncThunk('history/post', async ({ formData, id }, { rejectWithValue }) => {
  try {
    const response = await axiosApi.post(`player/history/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const updateHistory = createAsyncThunk('history/update', async ({ data, id }, { rejectWithValue }) => {
  try {
    const response = await axiosApi.put(`player/history/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const gethistory = createAsyncThunk('history/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get(`player/history/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const getAnounce = createAsyncThunk('anounce/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/announcements', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const getAnounceAgents = createAsyncThunk('anounceAgents/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/announcementsAgents', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const getEvent = createAsyncThunk('event/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/events/other-clubs', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )

    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const addVideo = createAsyncThunk('video/add', async (formatData, { rejectWithValue }) => {
  try {
    const response = await axiosApi.post('player/addVideo', formatData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const getVideo = createAsyncThunk('video/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/videos', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
//notification
export const getNotification = createAsyncThunk('notification/get', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get('player/notifications', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const deleteVideo = createAsyncThunk('video/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosApi.delete(`player/videos/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const deleteHistory = createAsyncThunk('history/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosApi.delete(`player/history/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const searchAnnonces = createAsyncThunk('announce/search', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get(`player/announcements/search?${params}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const searchAnnoncesAgents = createAsyncThunk('announceAgents/search', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosApi.get(`player/announcementsAgents/search?${params}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
// export const searchAnnonces = createAsyncThunk('announce/search', async (params, { rejectWithValue }) => {
//   try {
//     const response = await axiosApi.get(`player/announcements/search?${params}`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('auth_token')}`
//       }
//     }
//     )
//     return response.data
//   } catch (error) {
//     console.log(error)
//     return rejectWithValue(error)
//   }
// })

export const postuler = createAsyncThunk('postuler', async (formData, { rejectWithValue }) => {

  try {
    const response = await axiosApi.post(`player/application`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})

export const getApplication = createAsyncThunk(
  'getApplication',
  async (_, { rejectWithValue }) => { // <-- Correction ici
    try {
      const response = await axiosApi.get('player/applications', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('auth_token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteApplication = createAsyncThunk('application/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosApi.delete(`player/application/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})
export const updateApplication = createAsyncThunk('application/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await axiosApi.update(`player/application/${id}`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
      }
    }
    )
    return response.data
  } catch (error) {
    console.log(error)
    return rejectWithValue(error)
  }
})








// Création du Slice
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    error: null,
    success: null,
    profile: {},
    performance: [],
    announces: [],
    announcesAgents: [],
    anounce: {},
    history: [],
    videos: [],
    application: [],
    event: [],
    notifications: []
  },
  reducers: {
    resetProfileFlag: (state) => {
      state.success = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = action.payload
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.error = action.payload
      })

      //addHistory
      .addCase(addhistory.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(addhistory.fulfilled, (state, action) => {
        // state.history.push(action.payload)
        state.history = Array.isArray(action?.payload?.history) ? action.payload?.history : [];
      })
      .addCase(addhistory.rejected, (state, action) => {
        state.error = action.payload
      })

      //gettvideos
      .addCase(getVideo.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getVideo.fulfilled, (state, action) => {
        state.videos = Array.isArray(action.payload.videos) ? action?.payload?.videos : [];
      })
      .addCase(getVideo.rejected, (state, action) => {
        state.error = action.payload
      })

      //addvideos
      .addCase(addVideo.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(addVideo.fulfilled, (state, action) => {
        state.videos.push(action.payload.video)
      })
      .addCase(addVideo.rejected, (state, action) => {
        state.error = action.payload
      })

      //getHistory
      .addCase(gethistory.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(gethistory.fulfilled, (state, action) => {
        state.history = action.payload
      })
      .addCase(gethistory.rejected, (state, action) => {
        state.error = action.payload
      })

      //getNotification
      .addCase(getNotification.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        state.notifications = action.payload
      })
      .addCase(getNotification.rejected, (state, action) => {
        state.error = action.payload
      })

      //getEvent
      .addCase(getEvent.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getEvent.fulfilled, (state, action) => {
        state.event = action.payload
      })
      .addCase(getEvent.rejected, (state, action) => {
        state.error = action.payload
      })

      //getApplication
      .addCase(getApplication.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        state.application = action.payload
      })
      .addCase(getApplication.rejected, (state, action) => {
        state.error = action.payload
      })

      //getPerformance
      .addCase(getPerformance.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getPerformance.fulfilled, (state, action) => {
        state.performance = action.payload
      })
      .addCase(getPerformance.rejected, (state, action) => {
        state.error = action.payload
      })
      //addPerformance
      .addCase(addPerformance.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(addPerformance.fulfilled, (state, action) => {
        state.performance = action.payload
      })
      .addCase(addPerformance.rejected, (state, action) => {
        state.error = action.payload
      })
      //updatePerormance
      .addCase(ChangePerformance.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(ChangePerformance.fulfilled, (state, action) => {
        console.log(action.payload)
        // state.performance = action.payload
      })
      .addCase(ChangePerformance.rejected, (state, action) => {
        state.error = action.payload
      })

      //update
      .addCase(updateProfile.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.profile = action.payload
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.error = action.payload
      })
      //getanounces
      .addCase(getAnounce.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getAnounce.fulfilled, (state, action) => {
        state.announces = action.payload
      })
      .addCase(getAnounce.rejected, (state, action) => {
        state.error = action.payload
      })
      .addCase(getAnounceAgents.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(getAnounceAgents.fulfilled, (state, action) => {
        state.announcesAgents = action.payload
      })
      .addCase(getAnounceAgents.rejected, (state, action) => {
        state.error = action.payload
      })
      //getanounces
      .addCase(searchAnnonces.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(searchAnnonces.fulfilled, (state, action) => {
        state.announces = action.payload
      })
      .addCase(searchAnnonces.rejected, (state, action) => {
        state.error = action.payload
      })
      .addCase(searchAnnoncesAgents.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(searchAnnoncesAgents.fulfilled, (state, action) => {
        state.announcesAgents = action.payload
      })
      .addCase(searchAnnoncesAgents.rejected, (state, action) => {
        state.error = action.payload
      })
  },
})

// export const { resetProfileFlag } = profileSlice.actions

export default profileSlice.reducer
